// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskAttachments-module__container--2vg4q","delete":"TaskAttachments-module__delete--29HVq"};